import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS } from 'dealer-reducers'
import { RootReducer } from 'src/redux/rootReducer'

const OfferFetcher = (): JSX.Element => {
  const authStatus = useSelector((state: RootReducer) => state.authReducer.authorizedState)
  // this component listens on filters changes and fetches offers
  const dispatch = useDispatch()
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab])

  useEffect(() => {
    dispatch(FETCH_OFFERS({ tab: currentTab, refetch: true }))
    // eslint-disable-next-line consistent-return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters])

  useEffect(() => {
    // preload
    if (authStatus === 'authorized') {
      dispatch(FETCH_OFFERS({ tab: 'liked', refetch: true }))
      dispatch(FETCH_OFFERS({ tab: 'browse', refetch: true }))
      dispatch(FETCH_OFFERS({ tab: 'dealer_offers', refetch: true }))
      dispatch(FETCH_OFFERS({ tab: 'in_realization', refetch: true }))
      dispatch(FETCH_OFFERS({ tab: 'archive_accepted', refetch: true }))
      dispatch(FETCH_OFFERS({ tab: 'sold', refetch: true }))
    }
  }, [dispatch, authStatus])
  return <></>
}

export default OfferFetcher
